<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    :title="'使用记录'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="50%"
    top="10vh"
    :close-on-click-modal="false"
  >
    <el-table :data="itemList" v-loading="loading">
      <el-table-column type="index"></el-table-column>
      <el-table-column label="绑定日期">
        <template slot-scope="scope">
          <div v-if="scope.row.BindDay">
            {{scope.row.BindDay.substring(0,10)}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="Station.Name" label="绑定站点"></el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      ID: '',
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  methods: {
    onOpen() {
      this.ID = _.clone(this.value.ID);
      this.getItemList();
    },
    onClose() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
    },
    getItemList() {
      this.loading = true;
      this.$axios
        .get(`ipccode/${this.ID}`, {
          params: {
            with: ['Platform'],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
